// console.log('import.meta.env>>>', import.meta.env);

export const X_CID = import.meta.env.VITE_X_CID;
export const X_ACCESS_K = import.meta.env.VITE_X_ACCESS_K;
export const X_VERSION = import.meta.env.VITE_VERSION;
export const API_SECRET = import.meta.env.VITE_API_SECRET;
